import Onboarding from './onboarding';

export default Onboarding;
